import useFetchChartData from '@hooks/useFetchChartData'
import {
  AnalyticsGraphDataBase,
  FetchUserAnalyticsGraphParams,
} from '@models/user/UserAnalyticsGraph'
import { fetchAnalyticsGraph } from '@services/AnalyticsGraph'
import { useAppSelector } from '@store/hooks'
import { selectSelectedUser } from '@store/UserReducer'
import { tuttiFruttiPalette } from '@utils/colors'
import { durationFormatter } from '@utils/durationFormatter'
import dayjs from 'dayjs'
import { Area, AreaChart, Tooltip, XAxis, YAxis } from 'recharts'
import { DateAxisTick, DurationFormatedAxisTick } from '../common/AxisTicks'
import BaseChart from '../common/BaseChart'
import CustomTooltip from '../common/CustomTooltip'

const AverageSessionDurationForUser = () => {
  const user = useAppSelector(selectSelectedUser())
  const { data, isLoading, error } = useFetchChartData<
    FetchUserAnalyticsGraphParams,
    AnalyticsGraphDataBase
  >({
    entity: 'user',
    entityId: user?.id,
    kind: 'average-session-duration-for-user',
    fetchFunction: fetchAnalyticsGraph,
    dependencies: [user],
  })

  return (
    <BaseChart data={data} isLoading={isLoading} error={error} height={350}>
      <AreaChart data={data}>
        <YAxis
          dataKey="count"
          tickLine={false}
          stroke={'#bbb'}
          width={40}
          tick={(props) => <DurationFormatedAxisTick {...props} />}
        />
        <XAxis
          dataKey="label"
          tickLine={false}
          stroke={'#bbb'}
          height={20}
          tick={(props) => <DateAxisTick {...props} />}
        />
        <Tooltip
          content={(props) => (
            <CustomTooltip
              type="bar"
              {...props}
              valueFormatter={(value) =>
                durationFormatter(Number(value)) || '0s'
              }
              customLabelFormatter={(payload) =>
                dayjs(payload.label).format('D MMM YY')
              }
            />
          )}
        />
        <Area
          dataKey="count"
          type="monotone"
          fill={tuttiFruttiPalette[14]}
          stroke={tuttiFruttiPalette[12]}
          strokeWidth={1}
        />
      </AreaChart>
    </BaseChart>
  )
}

export default AverageSessionDurationForUser
